import React, { FC, useMemo } from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusSquare } from '@fortawesome/pro-light-svg-icons';
import Published from 'src/pages/TendersPage/TendersList/Published';
import { ICallOff } from 'src/models/callOffs/types';
import { useBidWorkspace } from 'src/models/bids/Bids/hooks';
import { WorkspaceBadge } from 'src/common';
import { IBidIdentifier } from 'src/models/bids/Bids/types';

interface Props {
  callOff: ICallOff;
  originIds?: string[];
  bidIds?: IBidIdentifier[];
}

export const CallOffsDndPreview: FC<Props> = ({ callOff, originIds, bidIds }) => {
  const { subject, date, isRead } = callOff;
  const itemCount = useMemo(() => {
    const originCount = originIds ? originIds.length : 0;
    const bidsCount = bidIds ? bidIds.length : 0;
    return originCount + bidsCount;
  }, [bidIds, originIds]);

  const { workspace: bidWs } = useBidWorkspace((bidIds && bidIds.length && bidIds[0].id) || '');
  return (
    <div
      className={classNames(styles.dragPreview, {
        [styles.isCouple]: itemCount === 2,
        [styles.isMultiple]: itemCount > 2,
        [styles.isRead]: isRead
      })}
    >
      <div className={styles.inner}>
        <span className={styles.colCheck}>
          <span className={styles.check}></span>
        </span>
        <span className={styles.colWs}>
          {bidWs ? (
            <WorkspaceBadge color={bidWs.color} title={bidWs.name} />
          ) : (
            <FontAwesomeIcon icon={faPlusSquare} className={styles.wsButtonIcon} />
          )}
        </span>
        <span className={styles.colPublished}>
          <Published published={date} />
        </span>
        <span className={styles.colTitle}>{subject}</span>
      </div>
    </div>
  );
};

export default CallOffsDndPreview;
